import {registerDataRouterApp} from '@github-ui/react-core/register-app'
import {PullRequestErrorState} from './components/PullRequestErrorState'
import {pullRequestsAppBuilder} from './config/app-builder'
import {pullRequestsCommitsRoute} from './routes/commits-route'
import {CommitsEntrypointFuture} from './routes/CommitsFuture'
import type {RouteObject} from '@github-ui/react-router'
import {pullRequestsLayoutRoute} from './routes/layout-route'
import {LayoutEntrypoint} from './routes/Layout'
import {pullRequestsFilesRoute, pullRequestsFilesWithRangeRoute} from './routes/files-route'
import {pullRequestsChangesRoute, pullRequestsChangesWithRangeRoute} from './routes/changes-route'
import {FilesEntrypointFuture, FilesWithRangeEntrypointFuture} from './routes/FilesFuture'
import {ChangesEntrypointFuture, ChangesWithRangeEntrypointFuture} from './routes/ChangesFuture'
import {pullRequestsConversationsRoute} from './routes/conversations-route'
import {ConversationsEntrypoint} from './routes/Conversations'
import {isFeatureEnabled} from '@github-ui/feature-flags'

const commitsRouteWithLayout: RouteObject[] = [
  pullRequestsLayoutRoute.toRoute({
    ErrorBoundary: PullRequestErrorState,
    Component: LayoutEntrypoint,
    children: [
      pullRequestsCommitsRoute.toRoute({
        Component: CommitsEntrypointFuture,
      }),
    ],
  }),
]

const commitsRouteWithConversations: RouteObject[] = [
  pullRequestsLayoutRoute.toRoute({
    ErrorBoundary: PullRequestErrorState,
    Component: LayoutEntrypoint,
    children: [
      pullRequestsConversationsRoute.toRoute({
        Component: ConversationsEntrypoint,
      }),
      pullRequestsCommitsRoute.toRoute({
        Component: CommitsEntrypointFuture,
      }),
    ],
  }),
]

const dataRouterRoutes: RouteObject[] = [
  pullRequestsLayoutRoute.toRoute({
    ErrorBoundary: PullRequestErrorState,
    Component: LayoutEntrypoint,
    children: [
      pullRequestsCommitsRoute.toRoute({
        Component: CommitsEntrypointFuture,
      }),
      pullRequestsFilesRoute.toRoute({
        Component: FilesEntrypointFuture,
      }),
      pullRequestsFilesWithRangeRoute.toRoute({
        Component: FilesWithRangeEntrypointFuture,
      }),
      pullRequestsChangesRoute.toRoute({
        Component: ChangesEntrypointFuture,
      }),
      pullRequestsChangesWithRangeRoute.toRoute({
        Component: ChangesWithRangeEntrypointFuture,
      }),
    ],
  }),
]

const dataRouterRoutesWithConversations: RouteObject[] = [
  pullRequestsLayoutRoute.toRoute({
    ErrorBoundary: PullRequestErrorState,
    Component: LayoutEntrypoint,
    children: [
      pullRequestsConversationsRoute.toRoute({
        Component: ConversationsEntrypoint,
      }),
      pullRequestsCommitsRoute.toRoute({
        Component: CommitsEntrypointFuture,
      }),
      pullRequestsFilesRoute.toRoute({
        Component: FilesEntrypointFuture,
      }),
      pullRequestsFilesWithRangeRoute.toRoute({
        Component: FilesWithRangeEntrypointFuture,
      }),
      pullRequestsChangesRoute.toRoute({
        Component: ChangesEntrypointFuture,
      }),
      pullRequestsChangesWithRangeRoute.toRoute({
        Component: ChangesWithRangeEntrypointFuture,
      }),
    ],
  }),
]

export const pullRequestsApp = pullRequestsAppBuilder.createDataRouterAppFromRoutes(params => {
  const conversationsEnabled = isFeatureEnabled('prs_conversations_react')

  if (params.isEnabled('react_data_router_pull_request_files')) {
    if (conversationsEnabled) {
      return dataRouterRoutesWithConversations
    }

    return dataRouterRoutes
  }

  if (conversationsEnabled) {
    return commitsRouteWithConversations
  }

  return commitsRouteWithLayout
})

registerDataRouterApp(pullRequestsApp)
